export default __webpack_public_path__ + "static/Idea@mob_2x-d42ce33f4520e0efc90eebe258ee65a1.webp";